export function validUrl(urlValue) {
    let urlValid = false;
    try {
        const url = new URL(urlValue);
        if (url.protocol === 'http:' || url.protocol === 'https:') {
            urlValid = true;
        }
    }
    catch (e) {
        //do nothing
    }
    return urlValid;
}
